import React from 'react';
import { useRouter } from "next/router";
import moment from "moment";
import {useTranslation} from "next-i18next";
import styles from "../../../styles/Master.module.scss";
import MainButton from "../../ButtonsCont/MainButton";
import {master_address_select, master_schedule} from "../../../store/actions/master";
import ReviewItem from "../ReviewItem";
import {useDispatch} from "react-redux";

function PostComments(props) {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const router = useRouter();
    const d = new Date(props.free_day);
    moment.locale(props.language)
    const day_with_format = moment(d).format('D MMMM');
    const weekday = moment(d).format('ddd');
    const openRegisterMaster = () => {
        dispatch(master_address_select({ selected_service: props.service }));
        dispatch(master_schedule({
            calendar_value: {
                day: d.getDate(),
                month: d.getMonth() + 1,
                year: d.getFullYear()
            }
        }))
        router.push(`/master/${props.master_id}/register-master/?free_day=${props.free_day}&service=${props.service}`)
    };

    return (
        <div className={`d-flex flex-column ${styles.review_list}`}>
            {props.comments
                ? props.comments.map((item, index) => {
                    return <ReviewItem
                        key={index}
                        item={item}
                        language_code={props.language}
                    />
                })
                : null}
            {props.free_day ?
                <div className="d-flex flex-column align-items-center mt-3">
                    <MainButton
                        className="flex-column"
                        title={<>{t("reserve")} <span style={{
                            fontSize: '12px',
                            fontWeight: 'normal',
                            color: 'rgba(255, 255, 255, 0.8)',
                            marginLeft: '5px'
                        }} className="small-text">{weekday} {day_with_format}</span></>}
                        onClick={openRegisterMaster}
                    />
                </div>
                : null}
        </div>
    )
}

export default PostComments;
